/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Empty navigation targets open submenus without leaving the current page. */
document.addEventListener('click', function(event) {
  var target = event.target instanceof Element ? event.target.closest('.shopify-section__header a[data-type="menuitem"][aria-haspopup="true"]') : null;
  if (!target) return;
  var href = target.getAttribute('href');
  if (href === '#' || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?#$/i.test(href || '')) {
    event.preventDefault();
  }
});


/* Require an explicit grind choice before Warehouse's AJAX add handler runs.
   Server-side checkout validation is still needed to cover direct API clients. */
(function () {
  var allowed = ['Whole beans - حبوب بن', 'Espresso - اسبرسو', 'V60 - في ٦٠', 'Moccamaster - موكا ماستر', 'French Press - فرنش برس', 'Cold brew - كولد برو'];
  function validateGrind(form, event) {
    var owner = form && form.closest('[data-stockroom-grind-required]');
    if (!owner) return;
    var field = form.elements.namedItem('properties[Grind Level]');
    var value = field ? field.value : '';
    if (allowed.indexOf(value) !== -1) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var first = field && (field instanceof Element ? field : field[0]);
    var warning = owner.querySelector('[data-grind-warning]');
    if (!warning) {
      warning = document.createElement('p');
      warning.setAttribute('data-grind-warning', '');
      warning.setAttribute('role', 'alert');
      warning.className = 'alert alert--error';
      form.appendChild(warning);
    }
    warning.textContent = owner.getAttribute('data-grind-message');
    if (first) { first.focus(); form.reportValidity(); }
  }
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('button[type="submit"], input[type="submit"]');
    if (button && button.form) validateGrind(button.form, event);
  }, true);
  document.addEventListener('submit', function (event) { validateGrind(event.target, event); }, true);
  document.addEventListener('change', function (event) {
    if (event.target.name !== 'properties[Grind Level]') return;
    var owner = event.target.closest('[data-stockroom-grind-required]');
    var warning = owner && owner.querySelector('[data-grind-warning]');
    if (warning) warning.remove();
  });
})();
